import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './report-daily-vehicle.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ReportDailyVehicleDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const reportDailyVehicleEntity = useAppSelector(state => state.reportDailyVehicle.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="reportDailyVehicleDetailsHeading">
          <Translate contentKey="fleetSenseApp.reportDailyVehicle.detail.title">ReportDailyVehicle</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.id}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.createdDate">Created</Translate>
            </span>
          </dt>
          <dd>
            {reportDailyVehicleEntity.created ? (
              <TextFormat value={reportDailyVehicleEntity.created} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="totalAlerts">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.totalAlerts">Total Alerts</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.totalAlerts}</dd>
          <dt>
            <span id="totalSensorAlerts">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.totalSensorAlerts">Total Sensor Alerts</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.totalSensorAlerts}</dd>
          <dt>
            <span id="totalFenceCircleAlerts">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.totalFenceCircleAlerts">Total Fence Circle Alerts</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.totalFenceCircleAlerts}</dd>
          <dt>
            <span id="uptime">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.uptime">Uptime</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.uptime}</dd>
          <dt>
            <span id="idletime">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.downtime">Downtime</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.idletime}</dd>
          <dt>
            <span id="odometer">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.odometer">Odometer</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.odometer}</dd>
          <dt>
            <span id="travelledDistance">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.travelledDistance">Travelled Distance</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.travelledDistance}</dd>
          <dt>
            <span id="maximumSpeed">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.maximumSpeed">Maximum Speed</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.maximumSpeed}</dd>
          <dt>
            <span id="minimumSpeed">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.minimumSpeed">Minimum Speed</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.minimumSpeed}</dd>
          <dt>
            <span id="averageSpeed">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.averageSpeed">Average Speed</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.averageSpeed}</dd>
          <dt>
            <span id="maximumLoad">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.maximumLoad">Maximum Load</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.maximumLoad}</dd>
          <dt>
            <span id="minimumLoad">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.minimumLoad">Minimum Load</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.minimumLoad}</dd>
          <dt>
            <span id="averageLoad">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.averageLoad">Average Load</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.averageLoad}</dd>
          <dt>
            <span id="absActivations">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.absActivations">Abs Activations</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.absActivations}</dd>
          <dt>
            <span id="rssActivations">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.rssActivations">Rss Activations</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.rssActivations}</dd>
          <dt>
            <span id="brakeActivations">
              <Translate contentKey="fleetSenseApp.reportDailyVehicle.brakeActivations">Brake Activations</Translate>
            </span>
          </dt>
          <dd>{reportDailyVehicleEntity.brakeActivations}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.reportDailyVehicle.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{reportDailyVehicleEntity.truckImplement ? reportDailyVehicleEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.reportDailyVehicle.company">Company</Translate>
          </dt>
          <dd>{reportDailyVehicleEntity.company ? reportDailyVehicleEntity.company.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.reportDailyVehicle.user">User</Translate>
          </dt>
          <dd>{reportDailyVehicleEntity.user ? reportDailyVehicleEntity.user.login : ''}</dd>
        </dl>
        <Button tag={Link} to="/report-daily-vehicle" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/report-daily-vehicle/${reportDailyVehicleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ReportDailyVehicleDetail;
